module.exports = __webpack_public_path__ + "../resources/img/ic_auto_array_default.7493fc75.svg";